<template lang="html">
  <div v-if="league" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>
          Manual Draft
        </h2>
        <p>
          Click on a team name to add legislators.
          <b>Teams can have up to four Senators and six Representatives</b>.
          When you are done, click the "Finish Draft" button at the bottom of
          the page to finalize all picks and start your league's season.
        </p>
        <div v-for="t in league.teams" v-bind:key="t.id" class="col-12">
          <p>
            <draftTeam v-bind:team="t"></draftTeam>
          </p>
        </div>
        <div class="alert alert-info">
          <div class="">
            Done drafting? Click "Finish Draft" to start your league's season!
          </div>
          <button @click="finishDraft" class="mt-4 btn-info btn">
            Finish Draft
          </button>
        </div>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import Loader from "@/views/components/Loader";
import DraftTeam from "@/views/modules/DraftTeam";
import { getCookie } from "@/utils/cookies.js";
import moment from "moment";

export default {
  name: "ManualDraft",
  components: {
    loader: Loader,
    draftTeam: DraftTeam
  },
  data: function() {
    return {
      league: null,
      congress: null,
      congressNext: null,
      congressPrevious: null,
      congressSearch: "",
      myTeam: null,
      senators: null,
      representatives: null,
      search: {},
      searchResult: {},
      show: false
    };
  },
  created: function() {
    this.getLeague();
  },
  methods: {
    getLeague: function() {
      let app = this;
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          // app.prepareSearch(response.teams)
          app.checkStatus(response);

          // app.getTeamMembers(response.teams.length, 0);
        });
    },
    checkStatus: function(league) {
      let app = this;
      let is_commish = league.players.filter(
        player =>
          player.is_commissioner == true &&
          player.user.id == app.$store.state.auth.user_id
      );
      if (is_commish.length > 0) {
        if (league.draft_status == "Pending") {
          app.$router.push(`/leagues/${league.id}/`);
          app.$store.commit("alert/addMessage", {
            message:
              "The draft has not started for this league. Start the draft on the league settings page.",
            class: "danger",
            persist: false
          });
        } else if (league.draft_status == "Complete") {
          app.$router.push(`/leagues/${league.id}/`);
          app.$store.commit("alert/addMessage", {
            message: "The draft for this league is complete.",
            class: "danger",
            persist: false
          });
        } else {
          app.$store.commit("breadcrumb/updateDynamicLinks", {
            dynamic_links: [
              {
                static_name: ":league",
                dynamic_name: league.name,
                url: `/leagues/${league.id}`
              }
            ]
          });
          app.$store.commit("breadcrumb/display");
          app.league = league;
        }
      }
    },
    finishDraft: function() {
      let app = this;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        draft_status: "Complete",
        status: "In Progress",
        draft_date: moment()
          .utc()
          .format("YYYY-MM-DD")
      });
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.$router.push(`/leagues/${app.$route.params.leagueId}/`);
          app.$store.commit("alert/addMessage", {
            message:
              "Your draft is complete! The season for this league has begun.",
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message:
              "Unable to complete draft. Please try again later or contact us for support.",
            class: "danger",
            persist: false
          });
        }
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
